class ApiInternalError extends Error {
    constructor(message, statusCode) {
        super(message);
        this.name = 'ApiInternalError';
        this.statusCode = statusCode;
    }
}

export default ApiInternalError;
